export * from "./confluence-software-page.template";
export { ConfluenceSoftwarePageTemplate as default } from "./confluence-software-page.template";
